import { CASStatus, Permission } from '@cims-online/shared'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { useSubmittalTrackerContext } from '../../../../SubmittalTrackerContext'
import { Submittal } from '../../../../SubmittalTrackerContext/types'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import { useSoftRemoveCaSubmittalMutation } from 'schema'
import { useClosedDisabledMessage } from 'components/CIMSTable/common/hooks/useClosedDisabledMessage'

export function useRemoveOptions(): RemoveRowActionOptions<Submittal> {
  const { refetch } = useSubmittalTrackerContext()
  const [remove] = useSoftRemoveCaSubmittalMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemoveConstructionAdminSubmittal: {
        submittal: { sharePointFolderName },
      },
    }) => simpleRemoveNotification(sharePointFolderName),
  })
  return {
    permission: Permission.RemoveRestoreConstructionAdminSubmittal,
    disabled: useClosedDisabledMessage('removed', [
      CASStatus.Closed,
      CASStatus.Unlocked,
    ]),
    onRemove: async ({ id }) => {
      await remove({ variables: { id } })
      refetch()
    },
  }
}
